import React, { useState, useEffect } from "react";
import { StyleSheet, Alert, Platform } from "react-native";

import { isWeb } from "../../../helpers/utils";
import Dialog from "../common/dialog";

export default function OnboardingConfirmDialog({
  title,
  description,
  isOpen = false,
  onClose = () => {},
  onConfirm = () => {},
  cancelText = "Cancel",
  confirmText = "Confirm",
}) {
  const [showConfirmation, setShowConfirmation] = useState(false);
  useEffect(() => {
    openDialog();
  }, [isOpen]);

  const openDialog = () => {
    if (isWeb) {
      setShowConfirmation(isOpen);
      return;
    } else if (isOpen) {
      Alert.alert(
        title,
        description,
        [
          {
            text: cancelText,
            style: "cancel",
          },
          {
            text: confirmText,
            onPress: onConfirm,
          },
        ],
        { cancelable: true },
      );
    }
  };

  return (
    <>
      {showConfirmation ? (
        <Dialog.Container onClose={onClose}>
          <Dialog.Title>{title}</Dialog.Title>
          <Dialog.Description style={styles.confirmText}>
            {description}
          </Dialog.Description>
          <Dialog.Button label={cancelText} onPress={onClose} />
          <Dialog.Button label={confirmText} onPress={onConfirm} />
        </Dialog.Container>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  confirmText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 13,
    lineHeight: 16,
    letterSpacing: -0.078,
    color: "#2D3142",
  },
});
